import "./PrimarySelect.css"

export default function PrimarySelect(props) {
    const onChange = props.onChange
    const disabled = props.disabled || false
    const extraClassName = (props.extraClassName || "").trim()
    const options = props.options
    const defaultOption = props.defaultOption;
    let defaultValue = options[0]
    if (defaultOption) {
        defaultValue = defaultOption.value
    }
    const optionsJSX = options.map((option) => {
        return (
            <option key={option.value} value={option.value}>
                {option.title}
            </option>
        );
    })
    let className = "shadow appearance-none border rounded py-2 px-3 text-gray-700 leading-tight focus:shadow-outline"
    className = [className, extraClassName].join(" ")
    return (
        <select disabled={disabled} className={className} size="1" onChange={onChange} value={defaultValue}>
            {optionsJSX}
        </select>
    )
}